import Section from './Section.vue'

export const signInModule = {
  type: 4,
  component: Section,
  reset(localForm, ctx) {
    const { SIGN_IN_METHOD_FIXED_DAYS, buildDefaultSignInTiers } = ctx
    localForm.signInRule.method = SIGN_IN_METHOD_FIXED_DAYS
    localForm.signInRule.cycle_days = 1
    localForm.signInTiers = buildDefaultSignInTiers(1)
  },
  fillFromActivity(localForm, raw, ctx) {
    const {
      SIGN_IN_METHOD_FIXED_DAYS,
      SIGN_IN_REWARD_TYPE_COIN,
      SIGN_IN_REWARD_TYPE_NONE,
      SIGN_IN_REWARD_MODE_FIXED,
      SIGN_IN_REWARD_MODE_RANDOM,
      centsToYuanNumber,
      buildDefaultSignInTiers,
    } = ctx

    const cfg = raw.sign_in_config || raw.config || {}
    const rule = cfg.rule && typeof cfg.rule === 'object' ? cfg.rule : {}

    const cycleDays = Number(rule.cycle_days)
    localForm.signInRule.method = Number.isFinite(Number(rule.method)) ? Number(rule.method) : SIGN_IN_METHOD_FIXED_DAYS
    localForm.signInRule.cycle_days = Number.isFinite(cycleDays) && cycleDays > 0 ? cycleDays : 1
    localForm.signInTiers = buildDefaultSignInTiers(localForm.signInRule.cycle_days)

    const rawTiers = Array.isArray(cfg.tiers) ? cfg.tiers : []
    for (let i = 0; i < rawTiers.length; i += 1) {
      const rawTier = rawTiers[i]
      if (!rawTier) continue
      const dayIndex = Number(rawTier.day_index)
      const idx = dayIndex - 1
      if (!Number.isFinite(idx) || idx < 0 || idx >= localForm.signInTiers.length) continue

      const tier = localForm.signInTiers[idx]
      const rewardType = Number(rawTier.reward_type)
      const rewardMode = Number(rawTier.reward_mode)

      tier.reward_type = Number.isFinite(rewardType) ? rewardType : SIGN_IN_REWARD_TYPE_NONE
      tier.reward_mode = Number.isFinite(rewardMode) ? rewardMode : SIGN_IN_REWARD_MODE_FIXED
      tier.multiple = Number.isFinite(Number(rawTier.multiple)) ? Number(rawTier.multiple) : 0
      tier.settled_count = Number.isFinite(Number(rawTier.settled_count)) ? Number(rawTier.settled_count) : 0

      if (tier.reward_type === SIGN_IN_REWARD_TYPE_COIN) {
        if (tier.reward_mode === SIGN_IN_REWARD_MODE_FIXED) {
          tier.gold = centsToYuanNumber(Number(rawTier.gold) || 0)
          tier.gold_min = undefined
          tier.gold_max = undefined
        } else {
          tier.gold = undefined
          tier.gold_min = centsToYuanNumber(Number(rawTier.gold_min) || 0)
          tier.gold_max = centsToYuanNumber(Number(rawTier.gold_max) || 0)
        }
      } else {
        tier.reward_mode = SIGN_IN_REWARD_MODE_FIXED
        tier.gold = undefined
        tier.gold_min = undefined
        tier.gold_max = undefined
        tier.multiple = 0
      }
    }
  },
  validate(localForm, ctx) {
    const {
      Message,
      SIGN_IN_REWARD_TYPE_COIN,
      SIGN_IN_REWARD_TYPE_NONE,
      SIGN_IN_REWARD_MODE_FIXED,
      SIGN_IN_REWARD_MODE_RANDOM,
    } = ctx

    if (!Array.isArray(localForm.signInTiers) || localForm.signInTiers.length === 0) {
      Message.error('请先配置签到档位')
      return false
    }

    const cycleDays = Number(localForm.signInRule?.cycle_days)
    if (!Number.isFinite(cycleDays) || cycleDays < 1) {
      Message.error('活动天数配置不合法')
      return false
    }

    const expectedLength = cycleDays
    if (localForm.signInTiers.length !== expectedLength) {
      Message.error('签到档位行数与活动天数不匹配')
      return false
    }

    for (let i = 0; i < localForm.signInTiers.length; i += 1) {
      const t = localForm.signInTiers[i]
      const rowIndex = i + 1
      if (!t) continue

      if (t.reward_type == null || t.reward_type === '') {
        Message.error(`签到档位（第${rowIndex}行）请选择奖励类型`)
        return false
      }
      if (Number(t.reward_type) === SIGN_IN_REWARD_TYPE_NONE) continue
      if (Number(t.reward_type) !== SIGN_IN_REWARD_TYPE_COIN) {
        Message.error(`签到档位（第${rowIndex}行）奖励类型请选择金币/无奖励`)
        return false
      }
      if (t.reward_mode == null || t.reward_mode === '') {
        Message.error(`签到档位（第${rowIndex}行）请选择奖励方式`)
        return false
      }

      const m = Number(t.multiple)
      if (!Number.isFinite(m) || m <= 0) {
        Message.error(`签到档位（第${rowIndex}行）奖励稽核倍数须大于0`)
        return false
      }

      if (Number(t.reward_mode) === SIGN_IN_REWARD_MODE_FIXED) {
        const g = Number(t.gold)
        if (!Number.isFinite(g) || g <= 0) {
          Message.error(`签到档位（第${rowIndex}行）固定奖励金币须大于0`)
          return false
        }
      } else if (Number(t.reward_mode) === SIGN_IN_REWARD_MODE_RANDOM) {
        const min = Number(t.gold_min)
        const max = Number(t.gold_max)
        if (!Number.isFinite(min) || min <= 0 || !Number.isFinite(max) || max <= 0) {
          Message.error(`签到档位（第${rowIndex}行）随机奖励金币区间须填写合法数字`)
          return false
        }
        if (max < min) {
          Message.error(`签到档位（第${rowIndex}行）随机奖励上限须大于等于下限`)
          return false
        }
      } else {
        Message.error(`签到档位（第${rowIndex}行）奖励方式请选择固定/随机`)
        return false
      }
    }
    return true
  },
  buildPayload(localForm, ctx) {
    const {
      SIGN_IN_METHOD_FIXED_DAYS,
      SIGN_IN_REWARD_TYPE_COIN,
      SIGN_IN_REWARD_TYPE_NONE,
      SIGN_IN_REWARD_MODE_FIXED,
      SIGN_IN_REWARD_MODE_RANDOM,
      yuanToCents,
    } = ctx

    const tiers = localForm.signInTiers.map(t => {
      const rewardType = Number(t.reward_type)
      const rewardMode = Number(t.reward_mode)
      const isCoin = rewardType === SIGN_IN_REWARD_TYPE_COIN

      if (!isCoin) {
        return {
          day_index: Number(t.day_index) || 0,
          reward_type: SIGN_IN_REWARD_TYPE_NONE,
          reward_mode: SIGN_IN_REWARD_MODE_FIXED,
          gold: 0,
          gold_min: 0,
          gold_max: 0,
          multiple: 0,
        }
      }

      if (rewardMode === SIGN_IN_REWARD_MODE_FIXED) {
        return {
          day_index: Number(t.day_index) || 0,
          reward_type: SIGN_IN_REWARD_TYPE_COIN,
          reward_mode: SIGN_IN_REWARD_MODE_FIXED,
          gold: yuanToCents(Number(t.gold) || 0),
          gold_min: 0,
          gold_max: 0,
          multiple: Number(t.multiple) || 0,
        }
      }

      return {
        day_index: Number(t.day_index) || 0,
        reward_type: SIGN_IN_REWARD_TYPE_COIN,
        reward_mode: SIGN_IN_REWARD_MODE_RANDOM,
        gold: 0,
        gold_min: yuanToCents(Number(t.gold_min) || 0),
        gold_max: yuanToCents(Number(t.gold_max) || 0),
        multiple: Number(t.multiple) || 0,
      }
    })

    return {
      sign_in_config: {
        rule: {
          method: SIGN_IN_METHOD_FIXED_DAYS,
          cycle_days: Number(localForm.signInRule?.cycle_days) || 0,
        },
        tiers,
      },
    }
  },
}

